import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "./Pages/Signup/Signup";
import Signin from "./Pages/Signin/Signin";
import Accounts from "./Pages/Accounts/Accounts";
import Dashboard from "./Pages/Dashboard/Dashbord";
import MemberPortalDashboard from "./Pages/Member Portal/Dashboard2/Dashboard2.js";
import Transactions from "./Pages/Transactions/Transactions";
import Home from "./Pages/Home/Home";
import Landing from "./Pages/Landingpage/Landing";

// --- FIXED IMPORTS (Removed references to deleted files) ---
import SavingsProducts from "./Pages/Settings/SavingsProducts";
import OrganizationSettings from "./Pages/Settings/OrganizationSettings";
import Settings from "./Pages/Settings/Settings.js";
import SettingsLoan from "./Pages/Settings/SettingsLoan.js";
 
import AddCompany from "./Pages/Settings/AddCompany";
import Optverify from "./Pages/Optverify/Optverify";
import Sections from "./Pages/Sections/Sections";
import Pricing from "./Pages/Pricing/Pricing";

import Receipts from "./Pages/Receipts/Receipts";
import Lodgement from "./Pages/Lodgement/Lodgement";
import Payments from "./Pages/Payments/Payments";
import Payables from "./Pages/Payables/Payables";
import Payment from "./Pages/Payment/Payment";
import PettyCash from "./Pages/PettyCash/PettyCash";
import Sales from "./Pages/Sales/Sales";
import Business from "./Pages/Business/Business";
import Reportss from "./Pages/Reportss/Reportss";
import Receivables from "./Pages/Receivables/Receivables";
import Purchaseinvoice from "./Pages/Purchaseinvoice/Purchaseinvoice";

import BankRecon from "./Pages/BankRecon/BankRecon";
import BankBank from "./Pages/BankRecon/BankBankRecon";
import Onboarding from "./Pages/Onboard/Onboard";
import Onboardingcopy from "./Pages/Onboard/Onboarding";
import Customers from "./Pages/Customers/Customers";
import Report from "./Pages/Reports/Report";
import BalanceSheetReport from "./Pages/BalanceSheetReport/BalanceSheetReport";
import CashFlowStatement from "./Pages/CashFlowStatement/CashFlowStatement";
import TrialBalance from "./Pages/TrialBalance/TrialBalance";
import Suppliers from "./Pages/Suppliers/Suppliers";
import ActionPage from "./Pages/ActionPage/ActionPage";
import Prchasing from "./Pages/Prchasing/Prchasing";
import Invoicedate from "./Pages/Invoicedate/Invoicedate";
import ListofAccount from "./Pages/ListofAccount/ListofAccount";
import NewItem from "./Pages/Purchaseinvoice/NewItem";
import Reportinvoice from "./Pages/Reportinvoice/Reportinvoice";
import Newitemproducts from "./Pages/Newitemproducts/Newitemproducts";
import MakeSale from "./Pages/Make sale/MakeSale";
import Preview from "./Pages/Invoice Preview/Preview";
import Previeww from "./Pages/CashManage/Previeww/Previeww.js";
import InvoiceDateReciptNew from "./Pages/InvoiceDateReciptNew/InvoiceDateReciptNew";
import PurchaseOrder from "./Pages/Inventory/PurchaseOrder/PurchaseOrder";
import NewPayables from "./Pages/Supplier Payables/Newpayable/Newitemproducts";
import SupplierPayables from "./Pages/Supplier Payables/Payables";
import Sale from "./Pages/Make sale/Sale";
import StockDelivary from "./Pages/StockDelivary/StockDelivary";
import NewPayment from "./Pages/Purchaseinvoice/NewPayment";
import NewPaymentPage from "./Pages/Purchaseinvoice/NewPaymentPage";
import LoanProducts from "./Pages/ManageUser/LoanProducts";
import ManageStore from "./Pages/ManageUser/ManageStore";
import PosReceipt from "./Pages/InvoiceDateReciptNew/PosReceipt";
import PrintRecipt from "./Pages/PrintRecipt/PrintRecipt";
import ReceiptPrintPreview from "./Pages/Receipts/PrintRecipt/PrintRecipt";
import CustomerSales from "./Pages/Customer Sales/CustomerSales";
import Actionpaged from "./Pages/ActionPaged/ActionPaged";
import PrintSalesReceipt from "./Pages/InvoiceDateReciptNew/PrintSalesReceipt";
import Managelocation from "./Pages/ManageUser/managelocation";
import ChangePassword from "./Pages/ChangePassword/ChangePassword"
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import NewPassword from "./Pages/NewPassword/NewPassword"
import Managecurrency from "./Pages/Managecurrency/Managecurrency.js"
import CustomerPersonalLedger from "./Pages/Customer Sales/PersonalLedger.js"
import EmployeePersonalLedger from "./Pages/Loan Allocated/PersonalLedger.js"

import SupplierLedger from "./Pages/SuppliersLedger/SuppliersLedger.js";
import SupplierPersonalLedger from "./Pages/SuppliersLedger/SuppliersPersonalLedger.js";
import MakeJournal from "./Pages/Generalledger/Make sale/MakeJournal.js";
import Journal from "./Pages/Generalledger/Journal/Journal.js";
import GeneralLedgerStatement from "./Pages/Reports/GeneralLedger report/GeneralLedgerStatement.jsx";
import EcobankCheque from "./Pages/EcobankCheque.jsx";
import EcobankChequeTemp from "./Pages/Cheque/EcobankChequeTemp.jsx";
import FundWallet from "./Pages/Wallet/FundWallet";
import WalletDetails from "./Pages/Wallet/WalletDetails";
import CreateOrder from "./Pages/CreateOrder/CreateOrder.js";
import RequestForm from "./Pages/RequestForm/RequestForm.js";
import FinishedGoods from "./Pages/FinishedGoods/FinishedGoods.js";
import MaterialIssued from "./Pages/MaterialIssued/MaterialIssued.js";
import CashManage from "./Pages/CashManage/CashManage.js"
import BankPayment from "./Pages/BankingPayment/Payment.js";
import Balance from "./Pages/Balance/Balance.js";
import PaymentReceipt from "./Pages/BankingPayment/PaymentReceipt/PaymentReceipt.js";
import PaymentVoucher from "./Pages/BankingPayment/PaymentVoucher/PaymentVoucher.js";
import EmployeeRecord from "./Pages/Employee Payroll/EmployeeRecord.js";
import SalaryStructure from "./Pages/Salary Structure/Salarystructure.js";
import SetupDeduction from "./Pages/Salary Structure/Setup Deduction/Deduction.js";
import MonthlyDeduction from "./Pages/Salary Structure/Monthly Deduction/Deduction.js";
import SetupAllowance from "./Pages/Salary Structure/Setup Allowance/Allowance.js";
import Payslip from "./Pages/Pay Slip/Payslip.js";
import PayslipNew from "./Pages/Pay Slip/PayslipNew.js";
import PayslipReciept from "./Pages/Pay Slip/PaymentVoucher/PaymentVoucher.js";
import MonthlySalaryCompetition from "./Pages/Monthly Salary competition/PaymentVoucher/PaymentVoucher.js";
import ComputationPayslipReciept from "./Pages/Monthly Salary competition/Payroll/PaymentVoucher.js";
import Login from "./Pages/Login/Logn.js";
import InviteResponse from "./Pages/InviteResponse";
import BusinessSetup from "./Pages/Business Setup/BusinessSetup.js";
import OnboardOTP from "./Pages/Onboarding OTP/OnboardOTP.js";
import PricingNew from "./Pages/Pricing New/PricingNew.js";
import PricingNewPayment from "./Pages/Pricing New payment/PricingNewPayment.js";
import WitholdingTaxPayable from "./Pages/Witholding Tax Payable/WitholdingTaxPayable.js";
import PayePayable from "./Pages/PAYE Payable/PayePayable.js";
import VatPayable from "./Pages/Value Added Tax Payable/VatPayable.js";
import PensionPayable from "./Pages/Pension Payable/PensionPayable.js";
// import BankPayments from "./Pages/BankingPayment/Payment.js";
import BankPaymentsrcpt from "./Pages/BankingPayment/Payment.js";
import AssetCategory from "./Pages/AssetCategory/AssetCategory.js";
import FixedAsset from "./Pages/FixedAsset/FixedAsset.js";
import AssetLocation from "./Pages/AssetLocation/AssetLocation.js";
import AssetAssignment from "./Pages/AssetAssignment/AssetAssignment.js";
import AssetDepriciation from "./Pages/AssetDepriciation/AssetDepriciation.js";
import AssetRevaluation from "./Pages/AssetRevaluation/AssetRevaluation.js";
import AssetDisposal from "./Pages/AssetDisposal/AssetDisposal.js";
import AssetMaintainance from "./Pages/AssetMaintainance/AssetMaintainance.js";
import AssetMovement from "./Pages/AssetMovement/AssetMovement.js";
import AssetDocuments from "./Pages/AssetDocuments/AssetDocuments.js";
import UploadBasicSalary from "./Pages/Upload Basic Salary/UploadBasicSalary.jsx";
import PayePayment from "./Pages/BankingPayment/PayePayment.js";
import WitholdingTaxPayment from "./Pages/Witholding Tax Payment/WitholdinTaxPayment.js";
import AddProduct from "./Pages/Settings/AddProducts.js";
import LoanPayment from "./Pages/LoanPayment/LoanPayment.js";
import LoanRequest from "./Pages/LoanPayment/LoanRequest/LoanRequest.js";
import Manageloans from "./Pages/ManageUser/manageloans.js";
import LoanAllocated from "./Pages/Loan Allocated/LoanAllocated.js";
import JournalSearch from "./Pages/Generalledger/Journal Search/JournalSearch.js";
import ManageIndustry from "./Pages/ManageIndustry/ManageIndustry.js";
import ChartOfAccount from "./Pages/Chart of Account/ChartOfAccount.js";
import UploadOpeningBal from "./Pages/Chart of Account/UploadOpeningBal.js";
import ConfirmOpeningBal from "./Pages/Chart of Account/ConfirmOpeningBal.js";
import ManualOpeningBal from "./Pages/Chart of Account/ManualOpeningBal.js";
import ReconciliationLedger from "./Pages/Reconciliation/BankBankRecon.jsx";
import BankStatement from "./Pages/Bank Statement/BankSatatement.jsx";
import BankStatementPreview from "./Pages/Bank Statement Preview/BankStatementPreview.jsx";
import ChartofAccountPreview from "./Pages/Dashboard/Components/DashboardHeader/Chart of account Preview/ChartofAccountPreview.jsx";
import MemberLedger from "./Pages/MemberLedger/MemeberLedger.js";
import PersonalLedger from "./Pages/Customer Sales/PersonalLedger.js";
import MemeberPersonalLedger from "./Pages/MemberLedger/MemebersPersonalLedger.js";
import Disbursement from "./Pages/Loan Disbursement/Disbursement.js";
import ManageRoles from "./Pages/Manage Roles/ManageRoles.js";
import Repayment from "./Pages/Repayment/Purchaseinvoice.js";
import LoanApplication from "./Pages/Loan Application/Purchaseinvoice.js";
import NewRepaymentItem from "./Pages/Repayment/NewItem.js";
import LoanApproval from "./Pages/Loan Approval/Purchaseinvoice.js";
import NewLoanApproval from "./Pages/Loan Approval/NewItem.js";
import AddProductsNew from "./Pages/Settings/AddProductsNew.js";
import AddLoanProductsNew from "./Pages/Settings/AddLoanProductsNew.js";
import MemberSavings from "./Pages/Savings/MemberSaving.js";
import NewLoanApplication from "./Pages/Loan Application/NewItem.js";
import ManageUser from "./Pages/ManageUser/ManageUser"; // REMOVED - File deleted/renamed to LoanProducts.js
import SavingsWithdrawals from "./Pages/Savings/SavingsWithdrawals";
import MemberCollections from "./Pages/Savings/MemberCollections.js";
import MemberLoanLedger from "./Pages/MemberLedger/MemeberLoanLedger.js";
import SavingsAccount from "./Pages/Savings/SavingsAccount.js";
import MemeberLedgerLoanPersonal from "./Pages/MemberLedger/MemebersPersonalLoan.js";
import DisbursementNew from "./Pages/Loan Disbursement/DisbursementNew.js";
import LoanRepayment from "./Pages/Loan Disbursement/LoanRepayment.js";
import ApproveLoan from "./Pages/Loan Approval/ApproveLoan.js";
import CustomerList from "./Pages/Customers/CustomerList.js";
import SavingsBalance from "./Pages/Reports/SavingsBalance.js";
import LoanBalance from "./Pages/Reports/LoanBalance.js";
import MonthlyDeductions from "./Pages/Savings/MonthlyDeductions.js";
import ActualMonthlyDeductions from "./Pages/Savings/ActualMonthlyDeductions.js";
import ExpectedMonthlyDeductions from "./Pages/Savings/ExpectedMonthlyDeductions.js";
import DeductionReport from "./Pages/Reports/DeductionReport.js";
import SummaryDeductionReport from "./Pages/Reports/SummaryDeductionReport.js";
import MemeberPaySlipReport from "./Pages/Reports/MemeberPaySlipReport.js";
import MemberRegistration from "./Pages/Member Portal/Member Registration/MemberRegistration.js";
import ManageApproval from "./Pages/Manage Roles/ManageApproval.js";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/settings/products&services/new-items/add-loan-product" element={<AddLoanProductsNew />} />
        <Route path="/settings/products&services/new-items/add-product" element={<AddProductsNew />} />
        <Route path="/transactions/receivables/customer-sales" element={<CustomerSales />} />
        <Route path="/transactions/loan-allocated" element={<LoanAllocated />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/fixed_assets/assetcategory" element={<AssetCategory/>} />
        <Route path="/fixed-assets/assetmovement"element={<AssetMovement/>} />
        <Route path="/fixed_assets/assetrevaluation" element={<AssetRevaluation/>} />
        <Route path="/fixed_assets/assetlocation" element={<AssetLocation/>} />
        <Route path="/fixed_assets/assetdisposal" element={<AssetDisposal/>} />
        <Route path="/fixed-assets/assetdocuments" element={<AssetDocuments/>} />
        <Route path="/fixed_assets/assetmaintainance" element={<AssetMaintainance/>} />
        <Route path="/fixed_assets/assetassignment" element={<AssetAssignment/>} />
        <Route path="/fixed_assets/assetdepreciation" element={<AssetDepriciation/>} />
        <Route path="/fixed_assets/fixedasset" element={<FixedAsset/>} />
        <Route path='/transactions/payables/supplier-ledger' element={<SupplierLedger />} />
        <Route path='/transactions/payables/supplier-personal-ledger' element={<SupplierPersonalLedger />} />
        <Route path='/savings/member_savings_ledger' element={<MemberLedger />} />
        <Route path='/members/savings-personal-ledger' element={<MemeberPersonalLedger />} />
        <Route path='/loans/members-loan-ledger' element={<MemeberLedgerLoanPersonal />} />
        <Route path='/savings/member-savings' element={<MemberSavings />} />
        <Route path='/savings/savings-account' element={<SavingsAccount />} />
        <Route path='/processing/deductions/monthly-deduction' element={<MonthlyDeductions />} />
        <Route path='/processing/deductions/actual-monthly-deduction' element={<ActualMonthlyDeductions />} />
        <Route path='/processing/deductions/expected-monthly-deduction' element={<ExpectedMonthlyDeductions />} />
        <Route path='/loans/member_loans_ledger' element={<MemberLoanLedger />} />
        <Route path='/savings/member-collections' element={<MemberCollections />} />
        <Route path="/transactions/newactionn" element={<Actionpaged />} />
        <Route path="/settings/change-password" element={<ChangePassword />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/modules/Accounting/Dashboard' element={<Dashboard />} />
        <Route path='/customer-personal-ledger' element={<CustomerPersonalLedger />} />
        <Route path='/employee-personal-ledger' element={<EmployeePersonalLedger />} />
        <Route path='/payment-receipt' element={<PaymentReceipt />} />
        <Route path='/loan-request' element={<LoanRequest />} />
        <Route path='/modules' element={<Sections />} />
        <Route path='/home' element={<Home />} />
        <Route path="/savings/withdrawals" element={<SavingsWithdrawals />} />

        {/* --- MERGED ROUTES (With Fixes) --- */}
        <Route path='/setup/savings-products' element={<Settings />} />
        <Route path='/settings/organization' element={<OrganizationSettings />} />
        <Route path='/members/members-profile' element={<OrganizationSettings />} />
        
        {/* Note: The file 'settings.js' was deleted. Re-create it if you need this page. */}
        {/* <Route path='/settings/product-services' element={<Settings />} /> */}
        
        <Route path='/settings/loan-products' element={<SettingsLoan />} />
        {/* <Route path='/loans/disbursements' element={<Disbursement />} /> */}
        <Route path='/loans/disbursements' element={<DisbursementNew />} />
        {/* <Route path='/loans/disbursementsss' element={<DisbursementNew />} /> */}
        <Route path='/loans/loan-repayment' element={<LoanRepayment />} />

        <Route path='/settings/add-company' element={<AddCompany />} />
        <Route path='/transactions/receivables/sales' element={<Transactions />} />
        <Route path='/members/members-database' element={<Customers />} />
        <Route path='/members/members-list' element={<CustomerList />} />
        <Route path='/reports/members-savings-balance' element={<SavingsBalance />} />
        <Route path='/reports/deduction-report' element={<DeductionReport />} />
        <Route path='/reports/summary-deduction-report' element={<SummaryDeductionReport />} />
        <Route path='/reports/member-pay-slip-report' element={<MemeberPaySlipReport />} />
        <Route path='/reports/members-loan-balance' element={<LoanBalance />} />
        <Route path='/transactions/payables/suppliers' element={<Suppliers />} />
        <Route path='/transactions/payables/payables' element={<Payables />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/modules" element={<Sections />} />
        <Route path="/home" element={<Home />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/transactions/newaction" element={<ActionPage />} />
        <Route path="/report/general-ledger" element={<GeneralLedgerStatement />} />
        <Route path="/transactions/cashReciept" element={<CashManage />} />
        <Route path="/accounting/cashmanage/cashReciept" element={<CashManage />} />
        <Route path="/reports/balancebroughtforward" element={<Balance />} />

        <Route path="/" element={<Login />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/business" element={<Business />} />
        <Route path="/business-setup" element={<BusinessSetup />} />
        <Route path="/otpverification" element={<Optverify />} />
        <Route path="/onboarding-otp" element={<OnboardOTP />} />
        <Route path="/optverification" element={<Optverify />} />
        <Route path="/home" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/pricing-new" element={<PricingNew />} />
        <Route path="/pricing-new-payment" element={<PricingNewPayment />} />
        <Route path="/chart-of-account" element={<ChartOfAccount />} />
        <Route path="/upload-opening-bal" element={<UploadOpeningBal />} />
        <Route path="/confirm-opening-bal" element={<ConfirmOpeningBal />} />
        <Route path="/manual-opening-bal" element={<ManualOpeningBal />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/transactions/payables/purchase" element={<Purchaseinvoice />} />
        <Route path="/loans/loan-applications" element={<LoanApplication />} />
        <Route path="/loans/loan-approval" element={<LoanApproval />} />
        {/* <Route path="/loans/approve-loan" element={<ApproveLoan />} /> */}
           <Route path="/loans/repayment" element={<Repayment />} />
        <Route path="/transactions/witholding-tax-payable" element={<WitholdingTaxPayable />} />
        <Route path="/transactions/paye-payable" element={<PayePayable />} />
        <Route path="/transactions/pension-payable" element={<PensionPayable />} />
        <Route path="/transactions/vat-payable" element={<VatPayable />} />
        <Route path="/transactions/receipts" element={<Receipts />} />
        <Route path="/payments" element={<Payments />} />
       
        <Route path="/reports/wht-payment" element={<WitholdingTaxPayment />} />
        <Route path="/transactions/sales-invoice/receivables" element={<Receivables />} />
        <Route path="/payroll/upload-basic-salary" element={<UploadBasicSalary />} />
        <Route path="/transactions/pettycash" element={<PettyCash />} />
        <Route path="/transactions/payment" element={<NewPaymentPage />} />
        <Route path="/transactions/payment/new_payment" element={<NewPayment />} />
        <Route path="/transactions/lodgement" element={<Lodgement />} />
        <Route path="/inventory/PurchaseOrder" element={<PurchaseOrder />} />
        <Route path="/inventory/supplier_payables" element={<SupplierPayables />} />
        <Route path="reportss" element={<Reportss />} />
        <Route path="/bankreconcillation" element={<BankRecon />} />
        <Route path="/accounting/bankstatement-preview" element={<BankStatementPreview />} />
        <Route path="/accounting/chartofaccount-preview" element={<ChartofAccountPreview />} />
        <Route path="/fixed-assets/banksreconcillation" element={<BankBank />} />
        <Route path="/transactions/sales-pos/makesale" element={<MakeSale />} />
        <Route path="/transactions/sales-pos" element={<Sale />} />
        <Route path="/accounting/journalentry/new-journal-entry" element={<MakeJournal />} />
        <Route path="/accounting/journalentry/journal-entry" element={<Journal />} />
        <Route path="/inventory/workProgress/createOrder" element={<CreateOrder />} />
        <Route path="/inventory/workProgress/rawMaterial" element={<RequestForm/>} />
        <Route path="/inventory/workProgress/finishedGoods" element={<FinishedGoods/>} />
        <Route path="inventory/workProgress/materialsending" element={<MaterialIssued/>} />

        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/onboarding_dup" element={<Onboardingcopy />} />
        <Route path="/report/financial-statements" element={<Report />} />
        <Route path="/listofaccount" element={<ListofAccount />} />
        <Route path="/balancesheet" element={<BalanceSheetReport />} />
        <Route path="/cashflow" element={<CashFlowStatement />} />
        <Route path="/reports/trailbalance" element={<TrialBalance />} />
        <Route path="/reportss" element={< Reportss />} />
        <Route path="/transactions/purchase-invoice/purchase/new-item" element={<NewItem />} />
        <Route path="/loans/repayment/new" element={<NewRepaymentItem />} />
        <Route path="/loans/loan-approval/new" element={<NewLoanApproval />} />
        <Route path="/loans/loan-application/new" element={<NewLoanApplication />} />
        <Route path="/reportinvoice" element={<Reportinvoice />} />
        <Route path="/invoice-preview" element={<Preview />} />
        <Route path="/invoice-previeww" element={<Preview />} />
        <Route path="/preview" element={<Previeww />} />
        <Route path="/invoicedate" element={<Invoicedate />} />
        <Route path="/invoicedaterecipt" element={<InvoiceDateReciptNew />} />
        <Route path="/printreceipts" element={<PrintRecipt />} />
        <Route path="/print-customer-receipt" element={<ReceiptPrintPreview />} />
        <Route path="/print_sales_recepits" element={<PrintSalesReceipt />} />
        <Route path="/inventory/prchasing" element={<Prchasing />} />
        <Route path="/settings/products&services/new-items/newitemproducts" element={<Newitemproducts />} />
        <Route path="/members/members-database/create-members" element={<AddProduct />} />
        <Route path="/inventory/supplier_payables/new-payables" element={<NewPayables />} />
        <Route path="/inventory/stocks_delivery" element={<StockDelivary />} />

        <Route path='/setup/loan-products' element={<SettingsLoan />} />
        
        {/* Note: The file 'ManageUser.js' was deleted. Re-create it if you need this page. */}
        <Route path='/administration/manage-users' element={<ManageUser />} />
        
        <Route path='/administration/manage-roles' element={<ManageRoles />} />
        <Route path='/administration/manage-approvals' element={<ManageApproval />} />

        <Route path="/settings/manage-store" element={<ManageStore />} />
        <Route path="/pos_receipt" element={<PosReceipt />} />
        <Route path="/settings/manage-location" element={<Managelocation />} />
        <Route path="/settings/manage-loans" element={<Manageloans />} />
        <Route path="/settings/manage-currency" element={<Managecurrency />} />
        <Route path="/settings/manage-industry" element={<ManageIndustry />} />
        <Route path="/newpassword" element={<NewPassword />} />
        <Route path="/cheque" element={<EcobankCheque />} />
        <Route path="/cheque_temp" element={<EcobankChequeTemp />} />
        <Route path="/banking_payment" element={<BankPayment />} />
        <Route path="/fixed_assets/payment" element={<BankPayment />} />
        <Route path="/wallet" element={<WalletDetails />} />
        <Route path="/wallet/fund" element={<FundWallet />} />
        <Route path="/transactions/bank-payments" element={<BankPaymentsrcpt />} />
        <Route path="/transactions/paye-payments" element={<PayePayment />} />
        <Route path="/transactions/loan-payments" element={<LoanPayment />} />
        <Route path="/payment-voucher" element={<PaymentVoucher />} />

         <Route path="/payroll/employee-record" element={<EmployeeRecord />} />
         <Route path="/payroll/salary-structure" element={<SalaryStructure />} />
         <Route path="/payroll/setup-deduction" element={<SetupDeduction />} />
         <Route path="/payroll/monthly-deduction" element={<MonthlyDeduction />} />
         <Route path="/payroll/setup-allowance" element={<SetupAllowance />} />
         <Route path="/reports/payslip" element={<Payslip />} />
         <Route path="/payslip" element={<PayslipNew />} />
         <Route path="/payslip-reciept" element={<PayslipReciept />} />
         <Route path="/payroll/monthly-salary-competition" element={<MonthlySalaryCompetition />} />
         <Route path="/payroll/monthly-salary-competition-slip" element={<ComputationPayslipReciept />} />
         <Route path="/invite-response" element={<InviteResponse />} />
         {/* <Route path="/member-dashboard" element={<MemberPortalDashboard />} />
         <Route path="/member-registration" element={<MemberRegistration />} /> */}

      </Routes>
    </Router>
  );
}

export default App;